/**
 * Currency utility functions — mirrors wbe-code/src/utils/currencyFormatter.ts
 */

import { IDealersCurrency } from "@/types";
import { roundDealerCurrencyExchange } from "./decimal";

interface FormatCurrencyOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export const formatCurrency = (
  amount: number,
  currency: string = 'GBP',
  options: FormatCurrencyOptions = {}
): string => {
  const {
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = options;

  try {
    const formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
    });
    return formatter.format(amount);
  } catch (error) {
    return `${currency} ${amount.toFixed(minimumFractionDigits)}`;
  }
};



export const formatDealerAmount = (
  gbpAmount: number,
  dealersCurrency?: IDealersCurrency | null,
  exchangeRate?: number,
): string => {
  if (dealersCurrency) {
    const rate = exchangeRate ?? 1;
    const converted = roundDealerCurrencyExchange(gbpAmount * rate);
    return formatCurrency(converted, dealersCurrency.dogma_isocurrencycode, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return formatCurrency(gbpAmount, "GBP");
};
